import './JukeboxPlayer.scss';

const JukeboxPlayer = () => {
    return (
        <div className='jukebox-player-container'>
            <div className='jukebox-player-header'>
                <div className='jukebox-player-picture'>
                    <img src="jukebox_carré.png" alt="photo de Ben Bridgen écoutant de la musique" />
                </div>
                <div className='jukebox-player-main'>
                    <div className='jukebox-player-user-titles'>
                        <div className='jukebox-player-user-title'>
                            <h1> Bienvenue Ben </h1>
                        </div>
                        <div className='jukebox-player-title-line'></div>
                    </div>
                    
                        <div className='jukebox-player-title'>
                            <h4>Premier Lecteur</h4>
                        </div>
                    <div className='jukebox-player-content'>
                        <div className='music-carousel'>
                        <div className='music-player-container'>

                            <div className='music-player-top'>
                                <div className='music-player-picture-container'>
                                    <div className='music-player-picture'></div>
                                </div>
                                <div className='music-player-artist-container'>
                                    <div className='music-player-artist-title'>
                                        Artist
                                    </div>
                                    <div className='music-player-track-title'>
                                        Soundtrack
                                    </div>
                                    <div className='music-player-timeline'></div>
                                    <div className='music-player-duration'>
                                        1:30
                                    </div>
                                    <div className='music-player-buttons'>
                                        <img src="prev.png" alt="bouton précédent" />
                                        <img src="play.png" alt="bouton précédent" />
                                        <img src="pause.png" alt="bouton précédent" />
                                        <img src="next.png" alt="bouton précédent" />
                                    </div>
                                </div>
                            </div>
                            <div className='music-player-bottom'>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                            </div>
                        </div>
                        <div className='music-player-container-1'>

                            <div className='music-player-top'>
                                <div className='music-player-picture-container'>
                                    <div className='music-player-picture'></div>
                                </div>
                                <div className='music-player-artist-container'>
                                    <div className='music-player-artist-title'>
                                        Artist
                                    </div>
                                    <div className='music-player-track-title'>
                                        Soundtrack
                                    </div>
                                    <div className='music-player-timeline'></div>
                                    <div className='music-player-duration'>
                                        1:30
                                    </div>
                                    <div className='music-player-buttons'>
                                        <img src="prev.png" alt="bouton précédent" />
                                        <img src="play.png" alt="bouton précédent" />
                                        <img src="pause.png" alt="bouton précédent" />
                                        <img src="next.png" alt="bouton précédent" />
                                    </div>
                                </div>
                            </div>
                            <div className='music-player-bottom'>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                            </div>
                        </div>
                        <div className='music-player-container-2'>

                            <div className='music-player-top'>
                                <div className='music-player-picture-container'>
                                    <div className='music-player-picture'></div>
                                </div>
                                <div className='music-player-artist-container'>
                                    <div className='music-player-artist-title'>
                                        Artist
                                    </div>
                                    <div className='music-player-track-title'>
                                        Soundtrack
                                    </div>
                                    <div className='music-player-timeline'></div>
                                    <div className='music-player-duration'>
                                        1:30
                                    </div>
                                    <div className='music-player-buttons'>
                                        <img src="prev.png" alt="bouton précédent" />
                                        <img src="play.png" alt="bouton précédent" />
                                        <img src="pause.png" alt="bouton précédent" />
                                        <img src="next.png" alt="bouton précédent" />
                                    </div>
                                </div>
                            </div>
                            <div className='music-player-bottom'>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                                <div className='music-player-artist-list-container'>
                                    <div className='music-player-title-list'>Artist - </div>
                                    <div className='music-player-track-list'>Track</div>
                                    <div className='music-player-duration-list'>1:30</div>
                                </div>
                            </div>
                        </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JukeboxPlayer;